/**
 * Locations
 */

jQuery(function($) {

    if($('#google-map').length){

        var map,
        mapOptions = {
            //mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoom: 6,
            center: new google.maps.LatLng(59,10.8),
            //mapTypeId: 'roadmap',
            styles: style_json
        },
        canada_bounds = new google.maps.LatLngBounds(),
        prov_hash =  window.location.hash.replace("#", "")

        function initMap() {
            map = new google.maps.Map(document.getElementById('google-map'), mapOptions);
        }

        initMap();

        function setupProvince(locations, province_data){
            var province_bounds = new google.maps.LatLngBounds();
            var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            var labelIndex = 0;

            for (var i = 0, length = locations.length; i < length; i++) {

                var data = filtered_locations[i],
                latLng = new google.maps.LatLng(data.lat, data.lng),
                //alpha_label = labels[labelIndex++ % labels.length],

                icon_style = {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: "#111111",
                    fillOpacity: 0.9,
                    strokeWeight: 0.4
                },

                icon_style_hover = {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 13,
                    fillColor: "#333333",
                    fillOpacity: 1,
                    strokeWeight: 0.4
                }

                // Creating a marker and putting it on the map
                var marker = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    title: data.title,
                    //label: {
                    //    text: alpha_label,
                    //    color: "#FEFEFE"
                    //},
                    icon: icon_style,
                });



                // Attaching a click event to the current marker
                (function(marker, data) {

                    var tel = data.phone.replace(/\D/g,'');

                    var window_content = '<div id="' + data.province + i + '" class="location-window ' + data.province + '">'
                    + '<strong>' + data.title + '</strong>'
                    + '<p class="address">' + data.address + '</p></div>';


                    var infoWindow = new google.maps.InfoWindow();

                    google.maps.event.addListener(marker, "click", function(e) {
                        //infoWindow.setContent(window_content);
                        //infoWindow.open(map, marker);
                        map.setCenter(marker.getPosition());
                        map.setZoom(13);

                    });

                    // Append to legend
                    $legend_window = $('aside .locations-list').append(window_content);

                    // Go to marker when clicked
                    $(document).on('click', '#' + data.province + i, function(e){
                        map.setCenter(marker.getPosition());
                        map.setZoom(13);
                        $('.locations').toggleClass('open');
                    })

                    $(document).on('mouseenter mouseleave', '#' + data.province + i, function(e){
                        if(e.type == 'mouseenter'){
                            //marker.setAnimation(google.maps.Animation.BOUNCE);
                            marker.setIcon(icon_style_hover);
                        } else {
                            marker.setIcon(icon_style);
                        }
                    })

                })(marker, data);

                province_bounds.extend(marker.getPosition());
                canada_bounds.extend(marker.getPosition());

            }

            $(document).find('#' + province_data.id).on('click', function(e){
                map.fitBounds(province_bounds);

                if(locations.length == 1){
                    map.setZoom(13);
                }
            })
        }

        function goToProvince(province, locations){

            var filtered_locations = $.grep(locations, function(n,b){
                return n.province === province;
            });

            $('aside .location-window').hide();
            $('aside .location-window.' + province).show();


            var province_bounds = new google.maps.LatLngBounds();

            for (var i = 0, length = filtered_locations.length; i < length; i++) {
                var data = filtered_locations[i],
                latLng = new google.maps.LatLng(data.lat, data.lng);
                province_bounds.extend(latLng);
            }

            map.fitBounds(province_bounds);

            if(filtered_locations.length == 1){
                map.setZoom(13);
            }
        }

        for (var i = 0, length = provinces.length; i < length; i++) {
            var province_data = provinces[i];

            var filtered_locations = $.grep(locations, function(n,b){
                return n.province === province_data.id;
            });

            if(filtered_locations.length > 0){
                //$('aside ul').append('<li><a id="' + province_data.id + '">' + province_data.province + '</a></li>');
                setupProvince(filtered_locations, province_data);
            }
        }

        map.fitBounds(canada_bounds);

        if(prov_hash) {
            goToProvince(prov_hash, locations);
        }

        $('.location-select select').on('change', function(e){
            //window.location.href = '/locations/#' + $(this).val();
            goToProvince($(this).val(), locations);
        })

        $('.locations main .close').on('click', function(e){
            $('.locations').removeClass('open');
        });

    }
})
